/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Log } from "../../../model/logging";
import type { UnityRootState } from "../../UnityAppStore";
import type {
  AuthOrchestrationStatus,
  IpAutoLoginError,
  IpAutoLoginStatus
} from "../signIn.types";
import {
  AUTH_ORCHESTRATION_IP_AUTO_LOGIN,
  AUTH_ORCHESTRATION_RESOLVING
} from "../signIn.types";

export const selectAuthOrchestrationStatus = (
  state: UnityRootState
): AuthOrchestrationStatus => state.signIn.authOrchestrationStatus;

export const selectIsAuthOrchestrationPending = (
  state: UnityRootState
): boolean => {
  const status: AuthOrchestrationStatus = state.signIn.authOrchestrationStatus;
  const configCount: number = state.signIn.authConfigurations.length;
  if (
    status === AUTH_ORCHESTRATION_RESOLVING ||
    status === AUTH_ORCHESTRATION_IP_AUTO_LOGIN
  ) {
    Log.d(
      "selectIsAuthOrchestrationPending",
      "returning true — status=" + status + " configs=" + String(configCount)
    );
    return true;
  }
  // "interactive", "failed", "completed" and "idle" are all terminal for
  // the orchestrator — nothing further will change the status on its own,
  // so the caller must be released. Reporting "pending" here (for example
  // because tivoIpAutoLoginIdp is configured) parks the splash screen
  // forever and makes the fallback walk unreachable.
  Log.d(
    "selectIsAuthOrchestrationPending",
    "returning false — status=" + status + " configs=" + String(configCount)
  );
  return false;
};

export const selectIpAutoLoginStatus = (
  state: UnityRootState
): IpAutoLoginStatus => state.signIn.ipAutoLoginStatus;

export const selectIpAutoLoginError = (
  state: UnityRootState
): IpAutoLoginError | null => state.signIn.ipAutoLoginError;

export const selectAttemptedAuthTypes = (state: UnityRootState): string[] =>
  state.signIn.attemptedAuthTypes;
